/* Stylesheet */

.secondary_menu_wrapper {
  position: absolute;
  --width: 492px;
  z-index: 100;

  .content_container {
    .wrapper_container {
      padding: 36px;
      min-height: 100%;
      border-radius: 12px 0px 0px 12px;
      background: var(--ion-color-dark-primary);
      overflow: hidden;

      .option_container {
        padding: 32px 21px 21px 21px;
      }
    }
  }
}
